module.exports = __webpack_public_path__ + "static/media/closeIcon3.c64a2f3b.svg";